import axios from "axios";
export const BASE_URL = "/";



export const getAskAndQuestion= () => {
  return axios.get(BASE_URL + `api/AskAndQuestion`);
};

export function getTosolHotolbor(current_page) {
  return axios.get(BASE_URL + `api/TosolHotolbor/` +current_page);
}
export function getToriinBusBaiguullaga(current_page) {
  return axios.get(BASE_URL + `api/ToriinBusBaiguullaga/` +current_page);
}
export function getAjAhuiNegj(current_page) {
  return axios.get(BASE_URL + `api/AjAhuiNegj/` +current_page);
}
export function getMergejiliinZuvluh(current_page) {
  return axios.get(BASE_URL + `api/MergejliinZubluh/` +current_page);
}

export function getTusgaiZovshoorol(current_page, data) {
  return axios.post(BASE_URL + `api/TusgaiZovshoorol/` +current_page, data);
}
export function getBurtegliinGerchilgee(current_page, data) {
  return axios.post(BASE_URL + `api/BurtegliinGerchilgee/` +current_page, data);
}
export function getMergejiluud() {
  return axios.get(BASE_URL + `api/mergejiluud`);
}
export function getSurgaltBaiguullaga(current_page, data) {
  return axios.post(BASE_URL + `api/SurgaltCollage/` +current_page, data);
}
export function getHutulbur(id) {
  return axios.get(BASE_URL + `api/hutulbur/`+id);
}
export function getSurgaltTuv(current_page, data) {
  return axios.post(BASE_URL + `api/SurgaltBaiguullaga/` +current_page, data);
}

// export function getStatistic(current_page, data) {
//   return axios.post(BASE_URL + `api/Statistic/` +current_page, data);
// }
export function getStatisticByCategory(torol_id,data) {
  return axios.post(BASE_URL + `api/StatisticByCategory/`+torol_id, data);
}
// export function getStatisticByCategory(torol_id, current_page, data) {
//   return axios.post(BASE_URL + `api/StatisticByCategory/`+torol_id+"/"+current_page, data);
// }
export function getStatisticCategory() {
  return axios.get(BASE_URL + `api/StatisticCategory`);
}


export function getSchoolItems() {
  return axios.get(BASE_URL + `api/SchoolItems`);
}
export function getBagshlahErhiinZereg() {
  return axios.get(BASE_URL + `api/Teacher`);
}
export function getLaws(cat_id, current_page, data) {
  return axios.post(BASE_URL + `api/HuuliErhZuis/`+cat_id+"/"+current_page, data);
}


export function getTetgelegFilterData() {
  return axios.get(BASE_URL + `api/TetgelegFilterData`);
}
export function getTetgelegData(current_page, data) {
  return axios.post(BASE_URL + `api/TetgelegPagingF/` +current_page, data);
}


export function getNews(current_page) {
  return axios.get(BASE_URL + `api/NewsBYAll/` +current_page);
}

export function getNewsDetails (id) {
  return axios.get(BASE_URL + `api/NewsBYId/` +id);
}
// export const postAuditor = (data) => {
//   return axios.post(BASE_URL + `api/AuditorReguest`, data);
// };
//

export const Commetns = (data) => {
  return axios.post(BASE_URL + `api/Comments`, data);
};

export function getMBSUTabout() {
  return axios.get(BASE_URL + `api/Greeting`);
}
